import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useNewUserAccessRights } from '@app/hooks';
import { getMenuItems } from '@app/pages/Warehouses/WarehouseOperations/utils';

import type { MenuProps } from 'antd';

export const useWarehouseOperationsHeader = () => {
  const navigate = useNavigate();

  const {
    userAccessRights: {
      Warehouse: {
        IsProductItemsAccept,
        IsProductItemsDecomission,
        IsProductItemsMove,
        IsProductItemsDelete,
      },
    },
  } = useNewUserAccessRights();

  const handleMenuClick: MenuProps['onClick'] = useCallback(
    ({ key }: { key: string }) => {
      navigate(key);
    },
    [navigate]
  );

  const items = getMenuItems({
    IsProductItemsAccept,
    IsProductItemsDecomission,
    IsProductItemsMove,
    IsProductItemsDelete,
  });

  return {
    handleMenuClick,
    items,
  };
};
